import React from 'react';

export default function HomePageHeaderImage() {
  return (
    <svg
      data-bbox="0 0.488 72.015 28.003"
      viewBox="0 0 72 29"
      height="29"
      width="72"
      xmlns="http://www.w3.org/2000/svg"
      data-type="shape"
    >
      <g>
        <path
          d="M41.202 1.012c-1.427.747-1.958 2.01-1.958 5.498 0 0 .722-.698 1.793-1.087a7.643 7.643 0 0 0 1.835-.996c1.206-.884 1.393-2.021 1.393-3.936 0 0-1.967-.053-3.063.52m-8.464.818c-1.164 1.026-1.504 2.661-1.504 2.661l-3.852 14.927L24.177 7.2c-.312-1.299-.875-2.904-1.765-3.99-1.134-1.383-3.439-1.47-3.685-1.47-.245 0-2.55.087-3.684 1.47-.89 1.086-1.453 2.691-1.765 3.99l-3.205 12.217L6.22 4.49s-.339-1.635-1.503-2.66C2.83.164 0 .52 0 .52l7.378 27.9s2.434.175 3.652-.446c1.6-.816 2.361-1.445 3.33-5.24.862-3.384 3.275-13.325 3.501-14.032.111-.35.252-1.185.866-1.185.628 0 .757.834.867 1.185.221.71 2.638 10.648 3.501 14.031.968 3.796 1.73 4.425 3.33 5.241 1.217.621 3.652.446 3.652.446L37.455.521s-2.83-.356-4.717 1.308m11.524 3.247s-.46.713-1.515 1.302c-.676.38-1.325.635-2.02.97-1.168.558-1.484 1.182-1.484 2.133V28.42s1.862.235 3.08-.386c1.567-.799 1.927-1.569 1.941-5.039V6.086l-.002.001v-1.01zm18.391 9.462L72.015.614s-3.95-.673-5.908 1.108c-1.25 1.14-2.65 3.188-2.65 3.188L60.01 9.876c-.167.258-.386.54-.735.54s-.568-.282-.735-.54L55.096 4.91s-1.4-2.049-2.65-3.188c-1.959-1.78-5.91-1.108-5.91-1.108L55.9 14.538 46.562 28.42s4.114.52 6.07-1.262c1.252-1.14 2.464-2.992 2.464-2.992l3.445-4.966c.167-.258.386-.539.735-.539.35 0 .568.281.735.54l3.445 4.965s1.282 1.852 2.534 2.992c1.956 1.781 6 1.262 6 1.262l-9.337-13.88z"
          fill-rule="evenodd"
        />
      </g>
    </svg>
  );
}
